import React, { useState } from 'react'
// import makeStyles from "@material-ui/core/styles/makeStyles";
import { useQuery } from '@apollo/client'
import {
  ME_INVEST_IN_BASE_CURRENCY,
} from '../../../../queriesAndMutations'
import { numberWithCommas } from '../../../../utils'
import { mandatoryKyc } from '../../../../utils/me'
import { useMe } from '../../../../myHooks'
import { usePublicSettings } from '../../../../myHooks/useSettings'
import AccountStatus from '../../../../components/AccountStatus'
import UpgradeLevelDialog from '../../../../components/UpgradeLevelDialog'
import { useTranslation } from 'react-i18next'

// const useStyles = makeStyles(() => ({
//   cursorPointer: {
//     cursor: "pointer",
//   },
//   itemCenterSpaceBetween: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//   },
// }));

const KycLevelBox = ({ hiddenIfLvlZero = false }) => {
  // const classes = useStyles();
  const { t } = useTranslation();
  const { data: { publicSettings = {} } = {} } = usePublicSettings();
  const {
    data: { me } = {},
  } = useMe();

  const {
    data: { meInvestInBaseCurrency = {} } = {},
    loading: loadingMeInvestInBaseCurrency,
  } = useQuery(ME_INVEST_IN_BASE_CURRENCY);

  // Thin/SSO users (or missing customer/kyc_levels) may omit current_lvl —
  // never read max/min without a safe default (post-SSO white-screen guard).
  const currentLvl = meInvestInBaseCurrency?.current_lvl || {};
  const maxInvestAmount =
    typeof currentLvl.max_invest_amount === 'number'
      ? currentLvl.max_invest_amount
      : Number(currentLvl.max_invest_amount) || 0;
  const minInvestAmount =
    typeof currentLvl.min_invest_amount === 'number'
      ? currentLvl.min_invest_amount
      : Number(currentLvl.min_invest_amount) || 0;
  const currentLevelNum = Number(currentLvl.level) || 0;

  const is_gto_sales = !!(me && (me.is_gtoswiss || me.is_internal_sales));
  const [isUpgradeLvlDialogOpen, setIsUpgradeLvlDialogOpen] = useState(false);

  const renderKYCStatusBox = () => (
    <span className="status-pending-dark status-l w-full">
      { t('lvl increase pending') }
    </span>
  );

  const renderZeroInvestAmount = () => {
    let kycStatusText;
    const kycStatus = me && me.kyc_status;
    if (kycStatus === "PENDING") {
      kycStatusText = (
        <>
          { t('Your CUSTOMERTYPE is Pending.', {CUSTOMERTYPE: me && me.customer ? "KYC" : me && me.customerCompany ? "KYB" : ""}) }
          <br />
          { t('We will email you a notification after processing your application, or please check your status here again later.') }
        </>
      );
    } else if (kycStatus === "NOT_SUBMITTED") {
      kycStatusText = (
        <>
          {t('To increase this limit, please complete additional KYC steps')}
        </>
      )
    } else {
      return " 0.";
    }
    return (
      <>
        {" 0. "}
        <span className="space space__8">{' '}</span>
        {kycStatusText}
      </>
    );
  };

  const {
    data: { me: userData } = {},
  } = useMe();
  const [values, setValues] = useState({
    ethAddressDialogOpened: false,
  });
  const changeEthAddressDialogState = (state) => () =>
    setValues({
      ...values,
      ethAddressDialogOpened: state,
    });

  const getBaseCurrency = () => {
    if (!publicSettings || !publicSettings.kyc_use_base_currency) {
      return 'CHF'
    }

    return (publicSettings.base_currency || 'chf').toUpperCase()
  }

  const renderAccountStatusCard = () => (
    <AccountStatus
      userData={userData}
      publicSettings={publicSettings}
      onOpenDialog={changeEthAddressDialogState(true)}
      onCloseDialog={changeEthAddressDialogState(false)}
      dialogOpen={values.ethAddressDialogOpened}
    />
  );

  const maxLevel = publicSettings && publicSettings.kyc_levels && publicSettings.kyc_levels[5] &&
    publicSettings.kyc_levels[5].enable && publicSettings.kyc_levels[5].enable.enable_lvl ? 5 : 4

  if (!loadingMeInvestInBaseCurrency) {
    return (
      <div className="tips">
        <div className="tips__list tips__list-clear tips__list-one-column">
          {hiddenIfLvlZero && currentLevelNum < 1 ? (
              ""
            ) : (
              <div className="tips__item flex__align_start">
                <div className="tips__icon tips__icon-number">
                  {!loadingMeInvestInBaseCurrency ? currentLevelNum : 1}
                </div>

                <div className="tips__detail">
                  <div className="tips__title">
                    { t('Level') }{" "}
                    {!loadingMeInvestInBaseCurrency ? currentLevelNum : 1}
                  </div>

                  <div className="tips__line">
                    <div className="refund__content">
                      { t('You can make purchases up to the value of') }{" "}

                      {!loadingMeInvestInBaseCurrency && maxInvestAmount === 0
                        ? renderZeroInvestAmount()
                        : `${getBaseCurrency()} ${numberWithCommas(
                            minInvestAmount
                          )}-${numberWithCommas(
                            maxInvestAmount
                          )}`}
                    </div>

                  </div>
                </div>
              </div>
            )
          }
        </div>

        {hiddenIfLvlZero && currentLevelNum < 1 ? (
            ""
          ) : (
            <div className="popular__button">
              {/* Thin product: investor_readonly / freeze_kyc_upgrade — hide upgrade when no type_customer or level incomplete */}
              {currentLevelNum !== maxLevel &&
                currentLvl.type_customer !== undefined &&
                mandatoryKyc(
                  is_gto_sales,
                  (publicSettings && publicSettings.accepted_mandatory_kyc) || {}
                ) &&
                !meInvestInBaseCurrency.kyc_lvl_change && (
                  <>
                    <button
                      type="button"
                      onClick={() => setIsUpgradeLvlDialogOpen(true)}
                      className="button-stroke button-small w-full text__center popular__button"
                    >
                      { t('Increase Level now') }
                    </button>
                    <div className="space space__8">{' '}</div>
                  </>
                )
              }

              {meInvestInBaseCurrency.kyc_lvl_change && (
                <>{renderKYCStatusBox()}</>
              )}

              {renderAccountStatusCard()}

              <UpgradeLevelDialog
                open={isUpgradeLvlDialogOpen}
                onClose={() => setIsUpgradeLvlDialogOpen(false)}
              />
            </div>
          )
        }
      </div>
    );
  }
  return <></>;
};

export default KycLevelBox;
